// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"91b6bbf7","145":"2c2e954e","690":"934ad50f"}[chunkId] + ".chunk.css";
};